/* Create a new file in your project, for example src/api.js.
Copy the API code from this URL:
https://raw.githubusercontent.com/courseraap/capstone/main/api.js
 */

const seededRandom = function (seed) {
    var m = 2**35 - 31;
    var a = 185852;
    var s = seed % m;
    return function () {
        return (s = s * a % m) / m;
    };
}

const fetchAPI = function(date) {
    let result = [];
    let random = seededRandom(date.getDate());

    for(let i = 17; i <= 22; i++) {
        if(random() < 0.5) {
            result.push(i + ':00');
        }
        if(random() > 0.25) {
            result.push(i + ':30');
        }
    }
    return result;
};
const submitAPI = function(formData) {
    return true;
};

export { fetchAPI, submitAPI };
